import React from 'react';
import { Icon } from '@iconify/react';

const KkpPublicationLinkButton = ({ url, type = 'mag' }) => {
  if (!url) return null;

  const isSet = type === 'set';

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="btn btn-sm btn-outline-secondary"
      title={isSet ? 'Ouvrir le set de table' : 'Ouvrir le magazine'}
      aria-label={isSet ? 'Ouvrir le set de table' : 'Ouvrir le magazine'}
    >
      <Icon icon={isSet ? 'mdi:table-furniture' : 'mdi:book-open-page-variant'} />
    </a>
  );
};

export default KkpPublicationLinkButton;
